import { ASSET_DESCRIPTION, ColumnConfig, ColumnText, CombinedPortfoliosMultiColumnGridExtractorConfig, DateFormatter, DefaultFormatter, FilterMapper, ISODateFormatter, LodashExtractor, NestedConditionalExtractor, NumberFormatter, StaticValueExtractor, StoreLodashExtractor, TabConfig, TablePerPortfolioMultipleSeriesExtractorConfig, TablePerPortfolioSeriesExtractorConfig } from '@ddt-web/data-service';
import { DateUtil } from '@ddt-web/generic-utils';
import * as has from 'lodash/has';

export const PORTFOLIO_NAME_COLUMN = new ColumnConfig(null, null, new StoreLodashExtractor(['families'], 'description'), 'name');


export const NAV_MONTHLY = new TabConfig(
	'nav-monthly',
	new ColumnConfig(new ColumnText('FUND_PERF_NAV_MONTHLY', 'Monthly Returns - NAV (%)'), null, null, null, null),
	new TablePerPortfolioMultipleSeriesExtractorConfig(
		[new FilterMapper(['positionDetails'], 'children', security => security.assetType === 'ASSET_TYPE_FUND')],
		null,
		[
			new ColumnConfig(new ColumnText('TICKER', 'Ticker', null, { align: 'left' }), null, new LodashExtractor('ticker'), 'ticker'),
			new ColumnConfig(new ColumnText('NAME', 'Name', null, { align: 'left' }), null, ASSET_DESCRIPTION, 'description'),
			new ColumnConfig(null, null, new LodashExtractor('portfolioId'), null, DefaultFormatter.instance, null, false),
			new ColumnConfig(
				new ColumnText('FUND_PERF_AOD', 'As of Date', null, { align: 'right' }),
				null,
				new LodashExtractor('monthlyReturnDate'),
				null,
				new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT, '-')
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_YTD', 'YTD', null, { align: 'right' }),
				null,
				new LodashExtractor('funds.returnYtd.numberValue'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_1YR', '1YR', null, { align: 'right' }),
				null,
				new LodashExtractor('funds.returnY1.numberValue'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_5YR', '5YR', null, { align: 'right' }),
				null,
				new LodashExtractor('funds.returnY5.numberValue'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_10Y', '10YR', null, { align: 'right' }),
				null,
				new LodashExtractor('funds.returnY10.numberValue'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_SI', 'Since Inception', null, { align: 'right' }),
				null,
				new LodashExtractor('funds.returnSinceInception.numberValue'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_INCEPTION_DATE', 'Inception Date', null, { align: 'right' }),
				null,
				new LodashExtractor('inceptionDate'),
				null,
				new ISODateFormatter(ISODateFormatter.SHORT)
			)
		],
		PORTFOLIO_NAME_COLUMN
	)
);

export const MKT_RETURN_MONTHLY = new TabConfig(
	'mkt-return-monthly',
	new ColumnConfig(new ColumnText('FUND_PERF_MKT_MONTHLY_RETURN', 'Monthly Returns - Market (%)+'), null, null, null, null),
	new TablePerPortfolioMultipleSeriesExtractorConfig(
		[new FilterMapper(['positionDetails'], 'children', security => security.assetType === 'ASSET_TYPE_FUND')],
		null,
		[
			new ColumnConfig(new ColumnText('TICKER', 'Ticker', null, { align: 'left' }), null, new LodashExtractor('ticker'), 'ticker'),
			new ColumnConfig(new ColumnText('NAME', 'Name', null, { align: 'left' }), null, ASSET_DESCRIPTION, 'description'),
			new ColumnConfig(null, null, new LodashExtractor('portfolioId'), null, DefaultFormatter.instance, null, false),
			new ColumnConfig(
				new ColumnText('FUND_PERF_AOD', 'As of Date', null, { align: 'right' }),
				null,
				new LodashExtractor('monthlyReturnDate'),
				null,
				new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT, '-')
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_YTD', 'YTD', null, { align: 'right' }),
				null,
				new LodashExtractor('funds.marketReturnYtd.numberValue'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_1YR', '1YR', null, { align: 'right' }),
				null,
				new LodashExtractor('funds.marketReturnY1.numberValue'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_5YR', '5YR', null, { align: 'right' }),
				null,
				new LodashExtractor('funds.marketReturnY5.numberValue'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_10Y', '10YR', null, { align: 'right' }),
				null,
				new LodashExtractor('funds.marketReturnY10.numberValue'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_SI', 'Since Inception', null, { align: 'right' }),
				null,
				new LodashExtractor('funds.marketReturnSinceInception.numberValue'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_INCEPTION_DATE', 'Inception Date', null, { align: 'right' }),
				null,
				new LodashExtractor('inceptionDate'),
				null,
				new ISODateFormatter(ISODateFormatter.SHORT)
			)
		],
		PORTFOLIO_NAME_COLUMN
	)
);

export const STD_NAV = new TabConfig(
	'std-nav',
	new ColumnConfig(new ColumnText('FUND_PERF_STD_NAV', 'Quarterly Returns - NAV (%) & Yield (%)'), null, null, null, null),
	new TablePerPortfolioMultipleSeriesExtractorConfig(
		[new FilterMapper(['positionDetails'], 'children', security => security.assetType === 'ASSET_TYPE_FUND')],
		null,
		[
			new ColumnConfig(new ColumnText('TICKER', 'Ticker', null, { align: 'left' }), null, new LodashExtractor('ticker'), 'ticker'),
			new ColumnConfig(new ColumnText('NAME', 'Name', null, { align: 'left' }), null, ASSET_DESCRIPTION, 'description'),
			new ColumnConfig(null, null, new LodashExtractor('portfolioId'), null, DefaultFormatter.instance, null, false),
			new ColumnConfig(
				new ColumnText('FUND_PERF_AOD', 'As of Date', null, { align: 'right' }),
				null,
				new LodashExtractor('sourceDates.performanceAsOf'),
				null,
				new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT, '-')
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_1YR', '1YR', null, { align: 'right' }),
				null,
				new LodashExtractor('standardPerformances.oneYearAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_5YR', '5YR', null, { align: 'right' }),
				null,
				new LodashExtractor('standardPerformances.fiveYearAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_10Y', '10YR', null, { align: 'right' }),
				null,
				new LodashExtractor('standardPerformances.tenYearAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_SI', 'Since Inception', null, { align: 'right' }),
				null,
				new LodashExtractor('standardPerformances.sinceInceptionAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_INCEPTION_DATE', 'Inception Date', null, { align: 'right' }),
				null,
				new LodashExtractor('inceptionDate'),
				null,
				new ISODateFormatter(ISODateFormatter.SHORT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_UNSUB_SEC_YIELD', 'Unsubsidized 30 Day SEC Yield (%)', null, { align: 'right' }),
				null,
				new LodashExtractor('funds.unsubsecYieldmo1.numberValue'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_SEC_YIELD', '30 Day SEC Yield (%)', null, { align: 'right' }),
				null,
				new LodashExtractor('funds.secYield.numberValue'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('UNSUBSIDIZED_7_DAY_SEC_YIELD', 'Unsubsidized 7 Day SEC Yield', null, { align: 'right' }),
				null,
				new LodashExtractor('funds.unsubsecYieldD7.numberValue'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('7_DAY_TRAILING_YIELD', '7 day Trailing Yield', null, { align: 'right' }),
				null,
				new LodashExtractor('funds.rnrTrailingD7Yield.numberValue'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			)
		],
		PORTFOLIO_NAME_COLUMN
	)
);

export const STD_MKT = new TabConfig(
	'std-mkt',
	new ColumnConfig(new ColumnText('FUND_PERF_STD_MKT', 'Quarterly Returns - Market (%)+'), null, null, null, null),
	new TablePerPortfolioMultipleSeriesExtractorConfig(
		[new FilterMapper(['positionDetails'], 'children', security => security.assetType === 'ASSET_TYPE_FUND')],
		null,
		[
			new ColumnConfig(new ColumnText('TICKER', 'Ticker', null, { align: 'left' }), null, new LodashExtractor('ticker'), 'ticker'),
			new ColumnConfig(new ColumnText('NAME', 'Name', null, { align: 'left' }), null, ASSET_DESCRIPTION, 'description'),
			new ColumnConfig(null, null, new LodashExtractor('portfolioId'), null, DefaultFormatter.instance, null, false),
			new ColumnConfig(
				new ColumnText('FUND_PERF_AOD', 'As of Date', null, { align: 'right' }),
				null,
				new LodashExtractor('sourceDates.performanceAsOf'),
				null,
				new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT, '-')
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_1YR', '1YR', null, { align: 'right' }),
				null,
				new LodashExtractor('standardPerformances.marketPriceOneYearAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_5YR', '5YR', null, { align: 'right' }),
				null,
				new LodashExtractor('standardPerformances.marketPriceFiveYearAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_10Y', '10YR', null, { align: 'right' }),
				null,
				new LodashExtractor('standardPerformances.marketPriceTenYearAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_SI', 'Since Inception', null, { align: 'right' }),
				null,
				new LodashExtractor('standardPerformances.marketPriceSinceInceptionAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_INCEPTION_DATE', 'Inception Date', null, { align: 'right' }),
				null,
				new LodashExtractor('inceptionDate'),
				null,
				new ISODateFormatter(ISODateFormatter.SHORT)
			)
		],
		PORTFOLIO_NAME_COLUMN
	)
);

export const LOAD_ADJ_RETURNS = new TabConfig(
	'load-adj-returns',
	new ColumnConfig(new ColumnText('FUND_PERF_LOAD_ADJ_RETURNS', 'Quarterly Returns - Load Adjusted (%)ⱡ'), null, null, null, null),
	new TablePerPortfolioMultipleSeriesExtractorConfig(
		[new FilterMapper(['positionDetails'], 'children', security => security.assetType === 'ASSET_TYPE_FUND')],
		null,
		[
			new ColumnConfig(new ColumnText('TICKER', 'Ticker', null, { align: 'left' }), null, new LodashExtractor('ticker'), 'ticker'),
			new ColumnConfig(new ColumnText('NAME', 'Name', null, { align: 'left' }), null, ASSET_DESCRIPTION, 'description'),
			new ColumnConfig(null, null, new LodashExtractor('portfolioId'), null, DefaultFormatter.instance, null, false),
			new ColumnConfig(
				new ColumnText('FUND_PERF_LOAD_ADJ_RETURNS_AOD', 'As of Date', null, { align: 'right' }),
				null,
				new LodashExtractor('sourceDates.performanceAsOf'),
				null,
				new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT, '-')
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_LOAD_ADJ_RETURNS_1YR', '1YR', null, { align: 'right' }),
				null,
				new LodashExtractor('standardPerformances.loadAdjustedOneYearAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_LOAD_ADJ_RETURNS_5YR', '5YR', null, { align: 'right' }),
				null,
				new LodashExtractor('standardPerformances.loadAdjustedFiveYearAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_LOAD_ADJ_RETURNS_10Y', '10YR', null, { align: 'right' }),
				null,
				new LodashExtractor('standardPerformances.loadAdjustedTenYearAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_SI', 'Since Inception', null, { align: 'right' }),
				null,
				new LodashExtractor('standardPerformances.loadAdjustedSinceInceptionAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('MAX_FRONT_LOAD', 'Max Front Load', null, { align: 'right' }),
				null,
				new LodashExtractor('assetAnalytics.maxFrontLoad'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('MAX_DEFERRED_LOAD', 'Max Deferred Load', null, { align: 'right' }),
				null,
				new LodashExtractor('assetAnalytics.maxDeferredLoad'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			)
		],
		PORTFOLIO_NAME_COLUMN
	)
);

export const PERFORMANCE_FEES = new TabConfig(
	'performance-fees',
	new ColumnConfig(new ColumnText('PERFORMANCE_FEES', 'Fees'), null, null, null, null),
	new TablePerPortfolioSeriesExtractorConfig(
		new FilterMapper(['positionDetails'], 'children', security => security.assetType === 'ASSET_TYPE_FUND'),
		new ColumnText('PERFORMANCE_FEES_1STCOLUMN_TITLE', 'Fees'),
		[
			new ColumnConfig(new ColumnText('TICKER', 'Ticker', null, { align: 'left' }), null, new LodashExtractor('ticker'), 'ticker'),
			new ColumnConfig(new ColumnText('NAME', 'Name', null, { align: 'left' }), null, ASSET_DESCRIPTION, 'description'),
			new ColumnConfig(null, null, new LodashExtractor('portfolioId'), null, DefaultFormatter.instance, null, false),
			new ColumnConfig(
				new ColumnText('FUND_PERF_AOD', 'As of Date', null, { align: 'right' }),
				null,
				new LodashExtractor('sourceDates.dataAsOf'),
				null,
				new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT, '-')
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_GEP', 'Gross Expense Ratio (%)', null, { align: 'right' }),
				null,
				new LodashExtractor('assetAnalytics.grossExpenseRatio'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_NER', 'Net Expense Ratio (%)', null, { align: 'right' }),
				null,
				new LodashExtractor('assetAnalytics.expenseRatio'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_PEW_TYPE', 'Prospectus Expense Waiver Type', null, { align: 'center' }),
				null,
				new NestedConditionalExtractor(
					holdings => holdings?.customClientProperties?.prospectusFeeReductionContractualReduction?.toLowerCase() === 'true',
					new NestedConditionalExtractor(
						holdings => has(holdings, 'customClientProperties.prospectusFeeReductionType'),
						new StaticValueExtractor('Contractual'),
						new StaticValueExtractor('-')
					),
					new NestedConditionalExtractor(
						holdings => has(holdings, 'customClientProperties.prospectusFeeReductionType'),
						new StaticValueExtractor('Non-Contractual'),
						new StaticValueExtractor('-')
					)
				)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_PEW_EXPIRATION_DATE', 'Prospectus Expense Waiver Exp. Date', null, { align: 'right' }),
				null,
				new LodashExtractor('customClientProperties.prospectusFeeReductionExpirationDate'),
				null,
				new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT, '-')
			)
		],
		PORTFOLIO_NAME_COLUMN
	)
);

export const PERFORMANCE_FEES_PDF = new TabConfig(
	'performance-fees-pdf',
	new ColumnConfig(new ColumnText('PERFORMANCE_FEES', 'Fees'), null, null, null, null),
	new CombinedPortfoliosMultiColumnGridExtractorConfig(
		new FilterMapper(['positionDetails'], 'children', security => security.assetType === 'ASSET_TYPE_FUND'),
		new ColumnText('FUND_PERF_TICKER', 'Ticker'),
		PORTFOLIO_NAME_COLUMN,
		new ColumnConfig(new ColumnText('FUND_PERF_TICKER', 'Ticker'), null, new LodashExtractor('ticker')),
		new ColumnConfig(null, null, new LodashExtractor('weight', 0), 'weight', new NumberFormatter(NumberFormatter.PERCENT)),
		[
			new ColumnConfig(new ColumnText('FUND_PERF_NAME', 'Name'), null, ASSET_DESCRIPTION, 'description'),
			new ColumnConfig(
				new ColumnText('FUND_PERF_AOD', 'As of Date'), null, new LodashExtractor('sourceDates.dataAsOf'), null,
				new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT, '-'), [], false
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_GEP', 'Gross Expense Ratio', null, { align: 'right' }),
				null,
				new LodashExtractor('assetAnalytics.grossExpenseRatio'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			)
		]
	)
);

export const STD_NAV_PDF = new TabConfig(
	'std-nav-pdf',
	new ColumnConfig(new ColumnText('FUND_PERF_STD_NAV', 'Standardized Performance NAV (%)'), null, null, null, null),
	new CombinedPortfoliosMultiColumnGridExtractorConfig(
		new FilterMapper(['positionDetails'], 'children', security => security.assetType === 'ASSET_TYPE_FUND'),
		new ColumnText('FUND_PERF_TICKER', 'Ticker'),
		PORTFOLIO_NAME_COLUMN,
		new ColumnConfig(new ColumnText('FUND_PERF_TICKER', 'Ticker'), null, new LodashExtractor('ticker')),
		new ColumnConfig(null, null, new LodashExtractor('weight', 0), 'weight', new NumberFormatter(NumberFormatter.PERCENT)),
		[
			new ColumnConfig(new ColumnText('FUND_PERF_NAME', 'Name'), null, ASSET_DESCRIPTION),
			new ColumnConfig(
				new ColumnText('FUND_PERF_AOD', 'As of Date'),
				null,
				new LodashExtractor('sourceDates.performanceAsOf'),
				null,
				new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT, '-'),
				[],
				false
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_1YR', '1YR'),
				null,
				new LodashExtractor('standardPerformances.oneYearAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_5YR', '5YR*'),
				null,
				new LodashExtractor('standardPerformances.fiveYearAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_10Y', '10YR*'),
				null,
				new LodashExtractor('standardPerformances.tenYearAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_SI', 'Since Inception*'),
				null,
				new LodashExtractor('standardPerformances.sinceInceptionAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_INCEPTION_DATE', 'Inception Date'),
				null,
				new LodashExtractor('inceptionDate'),
				null,
				new ISODateFormatter(ISODateFormatter.SHORT)
			)
		]
	)
);

export const LOAD_ADJ_RETURNS_PDF = new TabConfig(
	'load-adj-returns-pdf',
	new ColumnConfig(new ColumnText('FUND_PERF_LOAD_ADJ_RETURNS', 'Quarterly Returns - Load Adjusted (%)'), null, null, null, null),
	new CombinedPortfoliosMultiColumnGridExtractorConfig(
		new FilterMapper(['positionDetails'], 'children', security => security.assetType === 'ASSET_TYPE_FUND'),
		new ColumnText('FUND_PERF_TICKER', 'Ticker'),
		PORTFOLIO_NAME_COLUMN,
		new ColumnConfig(new ColumnText('FUND_PERF_TICKER', 'Ticker'), null, new LodashExtractor('ticker')),
		new ColumnConfig(null, null, new LodashExtractor('weight', 0), 'weight', new NumberFormatter(NumberFormatter.PERCENT)),
		[
			new ColumnConfig(new ColumnText('FUND_PERF_NAME', 'Name'), null, ASSET_DESCRIPTION),
			new ColumnConfig(
				new ColumnText('FUND_PERF_AOD', 'As of Date'),
				null,
				new LodashExtractor('sourceDates.performanceAsOf'),
				null,
				new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT, '-'),
				[],
				false
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_1YR', '1YR'),
				null,
				new LodashExtractor('standardPerformances.loadAdjustedOneYearAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_5YR', '5YR*'),
				null,
				new LodashExtractor('standardPerformances.loadAdjustedFiveYearAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_10Y', '10YR*'),
				null,
				new LodashExtractor('standardPerformances.loadAdjustedTenYearAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_SI', 'Since Inception*'),
				null,
				new LodashExtractor('standardPerformances.loadAdjustedSinceInceptionAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_INCEPTION_DATE', 'Inception Date'),
				null,
				new LodashExtractor('inceptionDate'),
				null,
				new ISODateFormatter(ISODateFormatter.SHORT)
			),
			new ColumnConfig(
				new ColumnText('MAX_FRONT_LOAD', 'Max Front Load', null, { align: 'right' }),
				null,
				new LodashExtractor('assetAnalytics.maxFrontLoad'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('DEFERRED_LOAD', 'Deferred Load', null, { align: 'right' }),
				null,
				new LodashExtractor('assetAnalytics.maxDeferredLoad'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			)
		]
	)
);

export const STD_MKT_PDF = new TabConfig(
	'std-mkt-pdf',
	new ColumnConfig(new ColumnText('FUND_PERF_STD_MKT', 'Standardized Performance Market (%)'), null, null, null, null),
	new CombinedPortfoliosMultiColumnGridExtractorConfig(
		new FilterMapper(['positionDetails'], 'children', security => security.assetType === 'ASSET_TYPE_FUND'),
		new ColumnText('FUND_PERF_TICKER', 'Ticker'),
		PORTFOLIO_NAME_COLUMN,
		new ColumnConfig(new ColumnText('FUND_PERF_TICKER', 'Ticker'), null, new LodashExtractor('ticker')),
		new ColumnConfig(null, null, new LodashExtractor('weight', 0), 'weight', new NumberFormatter(NumberFormatter.PERCENT)),
		[
			new ColumnConfig(new ColumnText('FUND_PERF_NAME', 'Name'), null, ASSET_DESCRIPTION),
			new ColumnConfig(
				new ColumnText('FUND_PERF_AOD', 'As of Date'),
				null,
				new LodashExtractor('sourceDates.performanceAsOf'),
				null,
				new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT, '-'),
				[],
				false
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_1YR', '1YR'),
				null,
				new LodashExtractor('standardPerformances.marketPriceOneYearAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_5YR', '5YR*'),
				null,
				new LodashExtractor('standardPerformances.marketPriceFiveYearAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_10Y', '10YR*'),
				null,
				new LodashExtractor('standardPerformances.marketPriceTenYearAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_SI', 'Since Inception*'),
				null,
				new LodashExtractor('standardPerformances.marketPriceSinceInceptionAnnualized'),
				null,
				new NumberFormatter(NumberFormatter.PERCENT)
			),
			new ColumnConfig(
				new ColumnText('FUND_PERF_INCEPTION_DATE', 'Inception Date'),
				null,
				new LodashExtractor('inceptionDate'),
				null,
				new ISODateFormatter(ISODateFormatter.SHORT)
			)
		]
	)
);
